export default function SelfPower() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 39C30.4934 39 39 30.4934 39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39Z" fill="#00D15C" />
            <path d="M16.8571 17.3529L15 15H11V25H15L22.4286 15H27V25H22.4286L20.5714 22.0588" stroke="white" strokeWidth="1.5" />
            <path opacity="0.6" d="M13 17H14.5V23H13V17Z" fill="white" />
            <path opacity="0.6" d="M23.5 17H25V23H23.5V17Z" fill="white" />
            <path d="M28.5 18H30V22H28.5V18Z" fill="white" />
        </svg>
    );
}
